
























































































































































































































































































































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
import { timeFormat } from "@/utils";
import RuleStrategyConfig from "./RuleStrategyConfig.vue";

@Component({
  name: "system",
  components: {
    RuleStrategyConfig,
  },
})
export default class CombinationProperty extends Vue {
  @Prop() result: any;
  @Prop() roleDetailsOptions: any;
  @Prop() ticketCategory: any;
  @Prop() seattreeList: any;
  @Prop() talkresultList: any;
  @Prop() dealmethodList: any;
  @Prop() staffList: any;

  @Provide() private ruleForm: any = {
    id: "",
    planName: "",
    time: [],
    sequence: "",
    distinguish: "", //区分方式
    company: "", //运营商
    status: "",
    seatGroup: "", //坐席组
    templateName: "", //名单模板
    callingType: "", //拨打模式
    repeatTimes: "", //最多拨打次数
    maxLostRate: "", //最大呼损率
    talkResult: "", //交谈结果处理
    voicemailRedial: "", //语音信箱是否重拨
  };
  @Provide() private seatItem: string = "";
  @Provide() private resultStrategies: string = ""; //最终提交数据 交谈处理结果
  @Provide() private initResultStrategies: string = ""; //初始值 交谈处理结果
  @Provide() private handleMethod: string = ""; //处理方式
  @Provide() private delayDays: string = ""; //延迟天数
  @Provide() private readValue: string = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;

  @Provide() private token: string | null = "";
  @Provide() private isSaved: any = false;
  @Provide() private msg: any = this.$message;
  @Provide() private newQuestion: any = {};
  @Provide() private timeSlotOptions: any = [
    { id: 0, name: "0:00" },
    { id: 1, name: "1:00" },
    { id: 2, name: "2:00" },
    { id: 3, name: "3:00" },
    { id: 4, name: "4:00" },
    { id: 5, name: "5:00" },
    { id: 6, name: "6:00" },
    { id: 7, name: "7:00" },
    { id: 8, name: "8:00" },
    { id: 9, name: "9:00" },
    { id: 10, name: "10:00" },
    { id: 11, name: "11:00" },
    { id: 12, name: "12:00" },
    { id: 13, name: "13:00" },
    { id: 14, name: "14:00" },
    { id: 15, name: "15:00" },
    { id: 16, name: "16:00" },
    { id: 17, name: "17:00" },
    { id: 18, name: "18:00" },
    { id: 19, name: "19:00" },
    { id: 20, name: "20:00" },
    { id: 21, name: "21:00" },
    { id: 22, name: "22:00" },
    { id: 23, name: "23:00" },
  ];
  @Provide() private companyOptions: any = [{ id: 18, name: "airudder_pre" }];
  //拨打模式
  @Provide() private callingTypeOptions: any = [
    { id: 1, name: "预测式外呼" },
    { id: 2, name: "渐进式外呼" },
  ];
  //语音信箱是否重拨
  @Provide() private voicemailRedialOptions: any = [
    { id: 1, name: "是" },
    { id: 0, name: "否" },
  ];
  @Provide() private details: any = ""; //详情
  @Provide() private detailsOptions: any = []; //详情
  @Provide() private statusOptions: any = [
    { id: 1, name: "authority.Enable" },
    { id: 2, name: "authority.Disable" },
  ]; //状态
  @Provide() private distinguishOptions: any = [
    { id: 1, name: "员工" },
    { id: 2, name: "authority.role" },
  ]; //区分方式
  @Provide() private templateNameOptions: any = [
    { id: "name_list_template", name: "name_list_template" },
  ]; //名单模版选项
  @Provide() private seatItemOptions: any = []; //坐席选项（根据坐席组联动）

  // 本地化的数据副本，避免直接修改 prop
  @Provide() private localTalkresultList: any = [];
  @Provide() private localDealmethodList: any = [];
  // 开始时间限制
  public pickerOptions1: any = {
    disabledDate: (time: Date) => {
      if (this.ruleForm.time[1]) {
        return (
          time.getTime() > new Date(this.ruleForm.time[1]).getTime() ||
          time.getTime() <= new Date().getTime() - 86400000
        );
      }
      return time.getTime() <= new Date().getTime() - 86400000;
    },
  };
  private created() {
    this.token = localStorage.getItem("token");
    this.details = this.result["details"];
    this.seatItem = this.result["seatItem"] || "";

    // ⭐ 只在编辑时传 init
    if (this.result?.resultStrategies) {
      this.initResultStrategies = this.result.resultStrategies;
      this.resultStrategies = this.result.resultStrategies;
    } else {
      this.initResultStrategies = "";
      this.resultStrategies = "";
    }

    this.delayDays = this.result.delayDays || "";

    this.ruleForm = { ...this.result };
    // 初始化区分方式和详情选项
    if (this.result.distinguish === "1") {
      this.readValue = "1";
      this.ruleForm.distinguish = Number(this.readValue);
      this.detailsOptions = this.staffList;
    } else if (this.result.distinguish === "2") {
      this.readValue = "2";
      this.ruleForm.distinguish = Number(this.readValue);
      this.detailsOptions = this.roleDetailsOptions;
    } else {
      this.ruleForm.distinguish = "";
    }

    // 初始化坐席选项（编辑模式下）
    if (this.ruleForm.seatGroup && Array.isArray(this.seattreeList)) {
      const selectedGroup = this.seattreeList.find(
        (item: any) => item.value === this.ruleForm.seatGroup
      );

      if (selectedGroup && Array.isArray(selectedGroup.childrenList)) {
        this.seatItemOptions = selectedGroup.childrenList.map((item: any) => ({
          label: item.label,
          value: item.value,
        }));
      }
    }

    // 转换 talkresultList 数据格式
    this.formatTalkresultList();
    // 转换 dealmethodList 数据格式
    this.formatDealmethodList();
  }

  // 格式化交谈结果列表
  private formatTalkresultList() {
    if (this.talkresultList && Array.isArray(this.talkresultList)) {
      // 如果数组第一个元素是字符串，说明是逗号分割的格式
      if (
        this.talkresultList.length > 0 &&
        typeof this.talkresultList[0] === "string"
      ) {
        const formattedList: any[] = [];
        this.talkresultList.forEach((item: string, index: number) => {
          formattedList.push({
            label: item.trim(),
            value: item.trim(),
          });
        });
        // 使用本地副本，而不是修改 prop
        this.localTalkresultList = formattedList;
      } else {
        // 如果已经是对象格式，直接复制
        this.localTalkresultList = [...this.talkresultList];
      }
    } else {
      this.localTalkresultList = [];
    }
  }

  // 格式化处理方式列表
  private formatDealmethodList() {
    if (this.dealmethodList && Array.isArray(this.dealmethodList)) {
      // 如果数组第一个元素是字符串，说明是逗号分割的格式
      if (
        this.dealmethodList.length > 0 &&
        typeof this.dealmethodList[0] === "string"
      ) {
        const formattedList: any[] = [];
        this.dealmethodList.forEach((item: string, index: number) => {
          // 分割逗号字符串
          const parts = item.split(",");
          if (parts.length >= 2) {
            formattedList.push({
              title: parts[0].trim(), // 第一部分作为显示文本
              value: parts[1].trim(), // 第二部分作为值
            });
          } else {
            // 如果没有逗号，使用索引作为value
            formattedList.push({
              title: item.trim(),
              value: String(index + 1),
            });
          }
        });
        // 使用本地副本，而不是修改 prop
        this.localDealmethodList = formattedList;
      } else if (
        this.dealmethodList.length > 0 &&
        typeof this.dealmethodList[0] === "object"
      ) {
        // 如果已经是对象格式，直接复制并确保有 title 字段
        this.localDealmethodList = this.dealmethodList.map((item: any) => ({
          title: item.title || item.label || item.name,
          value: item.value,
        }));
      } else {
        this.localDealmethodList = [];
      }
    } else {
      this.localDealmethodList = [];
    }
  }
  onPlanNameInput(val: string) {
    this.ruleForm.planName = val.replace(/[^A-Za-z0-9_]/g, "");
  }

  get rules() {
    if (
      this.ruleForm.planName != "" &&
      this.ruleForm.sequence != "" &&
      this.ruleForm.distinguish !== "" &&
      this.details !== "" &&
      this.ruleForm.seatGroup != "" &&
      this.ruleForm.templateName != "" &&
      this.ruleForm.callingType != "" &&
      this.ruleForm.repeatTimes != "" &&
      this.ruleForm.maxLostRate != "" &&
      this.ruleForm.voicemailRedial !== "" &&
      this.resultStrategies != "" &&
      this.resultStrategies != "[]"&&
      this.ruleForm.time[0] &&
      this.ruleForm.time[1] &&
      this.ruleForm.company &&
      this.ruleForm.status !== ""
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  // 选择区分方式
  private selectRole(val: any) {
    this.detailsOptions = [];
    this.details = "";
    if (val === 1) {
      this.detailsOptions = this.staffList;
    } else if (val === 2) {
      this.detailsOptions = this.roleDetailsOptions;
    }
  }
  // 坐席组变化时的处理
  private handleSeatGroupChange(val: any) {
    this.seatItem = ""; // 清空已选的坐席
    // 根据选中的坐席组value找到对应的数据
    if (val && Array.isArray(this.seattreeList)) {
      const selectedGroup = this.seattreeList.find(
        (item: any) => item.value === val
      );

      if (selectedGroup && Array.isArray(selectedGroup.childrenList)) {
        // 映射为新对象，确保响应式
        this.seatItemOptions = selectedGroup.childrenList.map((item: any) => ({
          label: item.label,
          value: item.value,
        }));
      } else {
        this.seatItemOptions = [];
      }
    } else {
      this.seatItemOptions = [];
    }
  }
  // 交谈结果处理变化
  private handleTalkResultChange(val: any) {
    // 清空处理方式和延迟天数
    this.handleMethod = "";
    this.delayDays = "";
  }
  private hideMsk() {
    this.hideContainer();
  }
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
  // 问题列表

  private submitForm() {
    let that = this;
    if (that.rules) {
      //  新建和编辑服务端非要用两个接口，咱也不敢说，咱也不敢问
      if (that.ruleForm.id === "") {
        that.saveAddRobot();
      } else {
        that.saveEditRobot();
      }
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      return false;
    }
  }

  onStrategyFromChildValue(val: string) {
    this.resultStrategies = val;
  }

  private params() {
    let _arg: any = {
      id: this.ruleForm.id,
      // 计划名称
      planName: this.ruleForm.planName,
      //任意时间点
      sequence: this.ruleForm.sequence,
      // 区分方式-员工/角色
      company: this.ruleForm.company,
      status: this.ruleForm.status,
      // 坐席组
      groupName: this.ruleForm.seatGroup,
      // 坐席（多选，转为字符串或数组，根据后端需求）
      agentName: this.seatItem,
      // 名单模板
      templateName: this.ruleForm.templateName,
      // 拨打模式
      callingType: this.ruleForm.callingType,
      // 最多拨打次数
      repeatTimes: this.ruleForm.repeatTimes,
      // 最大呼损率
      maxLostRate: this.ruleForm.maxLostRate,
      // 语音信箱是否重拨
      voicemailRedial: this.ruleForm.voicemailRedial,
      resultStrategies: this.resultStrategies,
    };

    _arg.userstaffids =
      this.ruleForm.distinguish === 1 ? this.details.toString() : ""; // 员工 ID
    _arg.usergroupids =
      this.ruleForm.distinguish === 2 ? this.details.toString() : ""; // 角色ID
    if (
      this.ruleForm.time &&
      this.ruleForm.time.length > 0 &&
      this.ruleForm.time[0]
    ) {
      // 开始时间 - 结束时间
      _arg.timeRange =
        timeFormat(this.ruleForm.time[0]) +
        " - " +
        timeFormat(this.ruleForm.time[1]);
    }
    return _arg;
  }
  // 保存新建
  private async saveAddRobot() {
    const { addCallingPlanReq, addCallingPlanRequest }: any = await import(
      "@/request/robotManage"
    );
    console.log("保存新建参数：", this.params());
    let res = await addCallingPlanRequest.handleHttp(
      addCallingPlanReq(this.params()),
      this
    );
    if (res && res.right) {
      this.isSaved = false;
      this.$message({
        message: "success",
        type: "success",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    } else {
      this.isSaved = false;
    }
  }
  // 保存编辑
  private async saveEditRobot() {
    const { editCallingPlanReq, editCallingPlanRequest }: any = await import(
      "@/request/robotManage"
    );
    console.log("编辑参数：", this.params());
    let res = await editCallingPlanRequest.handleHttp(
      editCallingPlanReq(this.params()),
      this
    );
    if (res && res.right) {
      this.isSaved = false;
      this.$message({
        message: "success",
        type: "success",
      });
      this.closeAddDialog(false);
      this.$emit("updateList");
    } else {
      this.isSaved = false;
    }
  }

  // lee 关闭弹窗
  private closeAddDialog(bool: boolean) {
    this.$emit("returnRiskReport", {
      isShow: true,
    });
  }
}
